"use client";

import { PageHeader } from "@/components/ui/page-header";
import { useState, type FormEvent } from "react";

export default function FeedbackPage() {
  const [feedback, setFeedback] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setStatus("loading");
    try {
      const res = await fetch("/api/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ type: "feedback", feedback, email }),
      });
      if (!res.ok) throw new Error("Failed");
      setStatus("success");
      setFeedback(""); setEmail("");
    } catch {
      setStatus("error");
    }
  };

  return (
    <div className="container py-12 md:py-16">
      <div className="mx-auto max-w-2xl">
        <PageHeader title="Share Feedback" />
        <p className="mt-2 text-lg text-[var(--color-text-muted)]">
          We&apos;d love to hear your thoughts.
        </p>
        <p className="mt-4 text-sm text-[var(--color-text-muted)]">
          Your feedback directly shapes the platform &mdash; from tool accuracy and interface design to
          performance and accessibility. If something felt slow, confusing, or broken, let us know. If you
          can share which tool and page you were using, it helps us reproduce and fix issues faster.
        </p>

        {status === "success" ? (
          <div className="mt-8 rounded-md border border-[var(--color-success-200)] bg-[var(--color-success-50)] p-6 text-center">
            <p className="font-medium text-[var(--color-success-700)]">Thank you! Your feedback has been received.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="mt-8 space-y-4">
            <div>
              <label className="block text-sm font-medium text-[var(--color-text-muted)]">Your Feedback</label>
              <textarea value={feedback} onChange={(e) => setFeedback(e.target.value)} required rows={4}
                placeholder="Tell us what you think..."
                className="mt-1 flex w-full rounded-md border border-[var(--color-border)] bg-[var(--color-surface)] px-3 py-2 text-sm text-[var(--color-text)] placeholder:text-[var(--color-text-subtle)] focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)] border-[var(--color-border)]  text-[var(--color-text)] placeholder:text-[var(--color-text-subtle)]" />
            </div>
            <div>
              <label className="block text-sm font-medium text-[var(--color-text-muted)]">Your Email (optional)</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="If you'd like a reply"
                className="mt-1 flex h-10 w-full rounded-md border border-[var(--color-border)] bg-[var(--color-surface)] px-3 py-2 text-sm text-[var(--color-text)] placeholder:text-[var(--color-text-subtle)] focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)] border-[var(--color-border)]  text-[var(--color-text)] placeholder:text-[var(--color-text-subtle)]" />
            </div>
            {status === "error" && (
              <p className="text-sm text-[var(--color-error-600)]">Failed to submit. Please try again.</p>
            )}
            <button type="submit" disabled={status === "loading"}
              className="inline-flex w-full items-center justify-center rounded-md bg-[var(--color-accent)] px-6 py-3 text-sm font-medium text-[var(--color-accent-fg)] hover:bg-[var(--color-accent-hover)] disabled:opacity-50 transition-colors">
              {status === "loading" ? "Submitting..." : "Submit Feedback"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
